export default __webpack_public_path__ + "static/solutions-link-icon6.url-3c6881cc7a5a2095f27c4835078d3db7.svg";